module.exports = __webpack_public_path__ + "img/skull_4_bj.55fede09.png";